/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Views_UnpinInputs */

const en_views_unpin = /** @type {(inputs: Views_UnpinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unpin ${i?.name} from the sidebar`)
};

const de_views_unpin = /** @type {(inputs: Views_UnpinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} von der Seitenleiste lösen`)
};

/**
* | output |
* | --- |
* | "Unpin {name} from the sidebar" |
*
* @param {Views_UnpinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_unpin = /** @type {((inputs: Views_UnpinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_UnpinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_unpin(inputs)
	return en_views_unpin(inputs)
});